// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import {getFirestore} from "firebase/firestore";
import {getFunctions, connectFunctionsEmulator} from "firebase/functions";
import {getStorage} from "firebase/storage";


// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

const firebaseConfig = {

    apiKey: process.env.REACT_APP_FB_API_KEY,

    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,

    databaseURL: process.env.REACT_APP_DATABASE_URL,

    projectId: process.env.REACT_APP_FB_PROJECT_ID,

    storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,

    messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,

    appId: process.env.REACT_APP_FB_APP_ID,

};


//Initialize & export Firebase
export const FirebaseApp = initializeApp(firebaseConfig);

//Initialize & export Firebase Authentication
export const Auth = getAuth(FirebaseApp);

//Initialize & export Firestore
export const Firestore = getFirestore(FirebaseApp);

export const FStorage = getStorage(FirebaseApp, `gs://${FirebaseApp.name}.appspot.com`);


//Initialize & export Functions
export const Functions = getFunctions(FirebaseApp, "europe-west3");
if (process.env.REACT_APP_EMULATOR === "true") {
    connectFunctionsEmulator(Functions, "localhost", 5001);
}
